import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Dialog} from "primereact/dialog";
import React from "react";
import {T} from "services/lang/LanguageService";

interface IDatasetsTitlesShowerProps {
    titlesAndOverriddenTitles: { title: string, overriddenTitle: string }[];
    dialog: boolean;
    setDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

const DatasetsTitlesShower = (props: IDatasetsTitlesShowerProps) => {
    const { dialog, setDialog } = props;

    return <Dialog
        header={T("word.datasets-titles")}
        visible={dialog}
        onHide={() => setDialog(false)}
        style={{ width: "50vw" }}
        draggable
    >
        <DataTable
            value={props.titlesAndOverriddenTitles}
            paginator
            rows={10}
            responsiveLayout="scroll"
        >
            <Column field="title" header={T("word.title")} sortable />
            <Column field="overriddenTitle" header={T("word.overridden-title")} sortable />
        </DataTable>
    </Dialog>
}

export default DatasetsTitlesShower